import { VAULT_VALUES } from "./mocks/vaultValuesMock";
import { getSharedNavData } from "./sharedNavService";
import { convertStringtoNumber } from "./vaultValuesConverter";
import i18n from "../utils/i18n";
import { capitalizeBrandPaths } from "../utils/utils";

/**
 * This function queries the Vault for the necessary values for the nav
 * @param local Whether or not the nav is in a localhost environment
 * @returns An object with the Vault Values in it
 */
export const getVaultValues = async (local: boolean) => {
    const onBlueGreen = window.location.host.includes("prod") || window.location.host.includes("uat7");
    const onPassive =
        onBlueGreen &&
        (window.location.host.includes("m1") ||
        window.location.host.includes("w1") ||
        window.location.host.includes("op1w") ||
        window.location.host.includes("op1m")
            ? true
            : false);

    const onPreProdCDN = window.location.host.includes("uat1.cdn");

    const onInternalLive = window.location.host.includes("live") && window.location.host.includes("gm.com");

    const useInternalValue = onPreProdCDN ? true : onBlueGreen && (onPassive ? false : onInternalLive);

    let vaultValues = {
        accessoriesChevroletPath: local
            ? VAULT_VALUES.accessoriesChevroletPath
            : onPassive
            ? "usfsn_config_accessoriesChevroletPath_passive_value"
            : useInternalValue
            ? "usfsn_config_accessoriesChevroletPath_internal_value"
            : "usfsn_config_accessoriesChevroletPath_value",
        partsChevroletPath: local
            ? VAULT_VALUES.partsChevroletPath
            : onPassive
            ? "usfsn_config_partsChevroletPath_passive_value"
            : useInternalValue
            ? "usfsn_config_partsChevroletPath_internal_value"
            : "usfsn_config_partsChevroletPath_value",
        chevroletPath: local ? VAULT_VALUES.chevroletPath : "usfsn_config_ChevroletPath_value",
        accessoriesChevroletStoreId: local
            ? VAULT_VALUES.accessoriesChevroletStoreId
            : "usfsn_config_accessoriesChevroletStoreId_value",
        partsChevroletStoreId: local ? VAULT_VALUES.partsChevroletStoreId : "usfsn_config_partsChevroletStoreId_value",

        accessoriesBuickPath: local
            ? VAULT_VALUES.accessoriesBuickPath
            : onPassive
            ? "usfsn_config_accessoriesBuickPath_passive_value"
            : useInternalValue
            ? "usfsn_config_accessoriesBuickPath_internal_value"
            : "usfsn_config_accessoriesBuickPath_value",
        partsBuickPath: local
            ? VAULT_VALUES.partsBuickPath
            : onPassive
            ? "usfsn_config_partsBuickPath_passive_value"
            : useInternalValue
            ? "usfsn_config_partsBuickPath_internal_value"
            : "usfsn_config_partsBuickPath_value",
        buickPath: local ? VAULT_VALUES.buickPath : "usfsn_config_BuickPath_value",
        accessoriesBuickStoreId: local
            ? VAULT_VALUES.accessoriesBuickStoreId
            : "usfsn_config_accessoriesBuickStoreId_value",
        partsBuickStoreId: local ? VAULT_VALUES.partsBuickStoreId : "usfsn_config_partsBuickStoreId_value",

        accessoriesGMCPath: local
            ? VAULT_VALUES.accessoriesGMCPath
            : onPassive
            ? "usfsn_config_accessoriesGMCPath_passive_value"
            : useInternalValue
            ? "usfsn_config_accessoriesGMCPath_internal_value"
            : "usfsn_config_accessoriesGMCPath_value",
        partsGMCPath: local
            ? VAULT_VALUES.partsGMCPath
            : onPassive
            ? "usfsn_config_partsGMCPath_passive_value"
            : useInternalValue
            ? "usfsn_config_partsGMCPath_internal_value"
            : "usfsn_config_partsGMCPath_value",
        gmcPath: local ? VAULT_VALUES.gmcPath : "usfsn_config_GMCPath_value",
        accessoriesGMCStoreId: local ? VAULT_VALUES.accessoriesGMCStoreId : "usfsn_config_accessoriesGMCStoreId_value",
        partsGMCStoreId: local ? VAULT_VALUES.partsGMCStoreId : "usfsn_config_partsGMCStoreId_value",

        accessoriesCadillacPath: local
            ? VAULT_VALUES.accessoriesCadillacPath
            : onPassive
            ? "usfsn_config_accessoriesCadillacPath_passive_value"
            : useInternalValue
            ? "usfsn_config_accessoriesCadillacPath_value"
            : "usfsn_config_accessoriesCadillacPath_value",
        partsCadillacPath: local
            ? VAULT_VALUES.partsCadillacPath
            : onPassive
            ? "usfsn_config_partsCadillacPath_passive_value"
            : useInternalValue
            ? "usfsn_config_partsCadillacPath_internal_value"
            : "usfsn_config_partsCadillacPath_value",
        cadillacPath: local ? VAULT_VALUES.cadillacPath : "usfsn_config_CadillacPath_value",
        accessoriesCadillacStoreId: local
            ? VAULT_VALUES.accessoriesCadillacStoreId
            : "usfsn_config_accessoriesCadillacStoreId_value",
        partsCadillacStoreId: local ? VAULT_VALUES.partsCadillacStoreId : "usfsn_config_partsCadillacStoreId_value",
        chevroletESpotPath: local
            ? "/wcs/resources/store/11201/espot/Shared_Navigation?responseFormat=json&numberContentToDisplay=200"
            : "usfsn_config_chevrolet_espot_path_value",
        buickESpotPath: local
            ? "/wcs/resources/store/11202/espot/Shared_Navigation?responseFormat=json&numberContentToDisplay=200"
            : "usfsn_config_buick_espot_path_value",
        gmcESpotPath: local
            ? "/wcs/resources/store/11203/espot/Shared_Navigation?responseFormat=json&numberContentToDisplay=200"
            : "usfsn_config_gmc_espot_path_value",
        cadillacESpotPath: local
            ? "/wcs/resources/store/11204/espot/Shared_Navigation?responseFormat=json&numberContentToDisplay=200"
            : "usfsn_config_cadillac_espot_path_value",
        unifiedCatalogId: local ? "3074457345616678718" : "usfsn_config_unifiedCatalogId_value",
        azureClientIdTargetable: local ? VAULT_VALUES.azureClientIdTargetable : "azure_client_id_targetable_value",
        azureAccessTokenBaseUrl: local ? VAULT_VALUES.azureAccessTokenBaseUrl : "azure_access_token_base_url_value",
        azureMobileClientPolicy: local
            ? VAULT_VALUES.azureMobileClientPolicy
            : "azure_mobile_client_policy_targetable_value"
    };

    return vaultValues;
};

/**
 * This function gathers all of the configuration values for the Nav
 * @param brand The current brand of the site the nav is on
 * @param local Whether or not the nav is in localhost
 * @returns an Object with all of the Configuration values
 */
export const getConfigurationValues = async (brand: string, local: boolean, sso: boolean) => {
    const mobileBreakpoint = local
        ? convertStringtoNumber(VAULT_VALUES.mobileBreakpoint)
        : convertStringtoNumber("usfsn_config_mobile_breakpoint_strnum_value");

    const vaultValues = await getVaultValues(local);

    const sharedNavData = await parseSharedNav(
        await getSharedNavData(await getESpotLink(brand, vaultValues)),
        vaultValues,
        sso,
        brand
    );

    const configurationValues = {
        sharedNavData: sharedNavData,
        mobileBreakpoint: mobileBreakpoint,
        azureClientIdTargetable: vaultValues.azureClientIdTargetable,
        azureAccessTokenBaseUrl: vaultValues.azureAccessTokenBaseUrl,
        azureMobileClientPolicy: vaultValues.azureMobileClientPolicy
    };

    return configurationValues;
};

/**
 * Parses the eSpot to get all the links and necessary data for the Shared Nav
 * @param sharedNavData The eSpot Data
 * @param vaultValues The Object of Vault Values
 * @param sso If the Nav should pass SSO
 * @param brand The brand of the site that the nav is currently on
 * @returns The object of the Shared Nav Data
 */
export const parseSharedNav = async (sharedNavData: object, vaultValues: any, sso: boolean, brand: string) => {
    // Handle token validation and URL modification flags
    const { shouldModifyUrls, idToken } = handleTokenValidation(getEnvironment(), vaultValues);

    let departments = {};
    let currentDepartmentNumber = "0";
    let currentColumnNumber = "0";

    for (let i = 0; i < sharedNavData["MarketingSpotData"][0]["baseMarketingSpotActivityData"].length; i++) {
        const currentContent = sharedNavData["MarketingSpotData"][0]["baseMarketingSpotActivityData"][i];
        const contentName = currentContent["contentName"];
        const contentNameSplit = contentName.split(" ");
        const category = currentContent["marketingContentDescription"][0]["marketingText"];

        if (contentNameSplit[1].toLowerCase() === "department" && contentNameSplit[3].toLowerCase() === "start") {
            // You Are in the Barriers
            currentDepartmentNumber = contentNameSplit[2];

            const departmentNumber = convertStringtoNumber(currentDepartmentNumber) - 1;

            departments[departmentNumber] = {
                name: category,
                columns: {},
                location: [],
                home: [],
                categoryHeader: false
            };
        } else if (
            contentNameSplit[2] === currentDepartmentNumber &&
            contentNameSplit[3].toLowerCase() === "allow" &&
            contentNameSplit[4].toLowerCase() === "list"
        ) {
            let currentDepartmentLocationRule = ["", []];
            currentDepartmentLocationRule[0] = await parseESpotLink(
                currentContent["MarketingContentDescription"][0]["xmktDesc_customField1"],
                vaultValues
            );
            currentDepartmentLocationRule[1] = category.split(",");
            departments[Number(currentDepartmentNumber) - 1].location = currentDepartmentLocationRule;
        } else if (
            contentNameSplit[2] === currentDepartmentNumber &&
            contentNameSplit[3].toLowerCase() === "column" &&
            contentNameSplit[5].toLowerCase() === "start"
        ) {
            // Set the current column
            currentColumnNumber = contentNameSplit[4];

            departments[Number(currentDepartmentNumber) - 1].columns[Number(currentColumnNumber) - 1] = [
                currentContent["MarketingContentDescription"][0]["xmktDesc_customField1"] || ""
            ];

            if (
                !departments[Number(currentDepartmentNumber) - 1]?.categoryHeader &&
                currentContent["MarketingContentDescription"][0]["xmktDesc_customField1"]
            ) {
                departments[Number(currentDepartmentNumber) - 1].categoryHeader = true;
            }
        } else if (
            contentNameSplit[2] === currentDepartmentNumber &&
            contentNameSplit[3].toLowerCase() === "column" &&
            contentNameSplit[5].toLowerCase() === "end"
        ) {
            // At the end
        } else if (
            !(contentNameSplit[1].toLowerCase() === "department" && contentNameSplit[3].toLowerCase() === "end")
        ) {
            // Adding the Categories
            const sharedBaseURL = await parseESpotLink(
                currentContent["MarketingContentDescription"][0]["xmktDesc_customField1"],
                vaultValues
            );

            let actualLink = sharedBaseURL;
            const eVar = getEVarConfig(actualLink);

            let isSSOEnabled = false;
            const currentEnvironment = getEnvironment();
            const environmentTypeNavLink = checkItemEnvironment(sharedBaseURL);

            //SSO should only ever return true and flip on from P/A to Onstar if there's no mobile id token
            if (
                sso === true &&
                !shouldModifyUrls &&
                (currentEnvironment === 0 || currentEnvironment === 1) &&
                (environmentTypeNavLink === 2 || environmentTypeNavLink === 3)
            ) {
                isSSOEnabled = true;
            }

            let eVarBrand = brand;
            if (eVarBrand === "cadillac") {
                eVarBrand = "ca";
            } else if (eVarBrand === "chevrolet") {
                eVarBrand = "ch";
            }

            if (sharedBaseURL.includes("categories")) {
                // On the Listing Page
                actualLink += isSSOEnabled ? (actualLink.includes("?") ? "&" : "?") + "isSSO=true" : "";
                actualLink += eVar ? (actualLink.includes("?") ? "&" : "?") + eVar.slice(1) : "";
            } else if (!sharedBaseURL.includes("?")) {
                actualLink += isSSOEnabled ? (actualLink.includes("?") ? "&" : "?") + "isSSO=true" : "";
                actualLink += eVar ? (actualLink.includes("?") ? "&" : "?") + eVar.slice(1) : "";
            } else {
                actualLink += isSSOEnabled ? (actualLink.includes("?") ? "&" : "?") + "isSSO=true" : "";
                actualLink += eVar ? (actualLink.includes("?") ? "&" : "?") + eVar.slice(1) : "";
            }

            /**
             * Modify URL structure based on destination:
             * - For OnStar: Prepend brand-specific domain and include original URL in state
             * - For Parts/Accessories: Append authentication parameters to existing URL
             */
            if (shouldModifyUrls) {
                const currentEnvironment = getEnvironment();
                const brandPath = vaultValues[`${brand}Path`] || "";
                const partsBrandPath = vaultValues[`parts${capitalizeBrandPaths(brand)}Path`] || "";
                const accessoriesBrandPath = vaultValues[`accessories${capitalizeBrandPaths(brand)}Path`] || "";
                const environmentTypeNavLink = checkItemEnvironment(sharedBaseURL);
                let state = { redirectPath: sharedBaseURL };
                let finalState;

                //check if current environment is P/A, only modifying onstar links
                if (currentEnvironment == 0 || currentEnvironment == 1) {
                    // OnStar environments (2 or 3) for the actual nav link
                    if (environmentTypeNavLink === 2 || environmentTypeNavLink === 3) {
                        finalState = encodeURIComponent(sharedBaseURL);
                        actualLink = `https://${brandPath}/myaccount/waypoint/auth.html?state=${finalState}&id_token=${idToken}`;
                    }
                } else {
                    // Parts environment (0) for the actual nav link
                    if (environmentTypeNavLink === 0) {
                        finalState = encodeURIComponent(JSON.stringify(state));
                        actualLink = `https://${partsBrandPath}/authenticate?state=${finalState}&id_token=${idToken}`;
                    }
                    // Accessories environment (1) for the actual nav link
                    else if (environmentTypeNavLink === 1) {
                        finalState = encodeURIComponent(JSON.stringify(state));
                        actualLink = `https://${accessoriesBrandPath}/authenticate?state=${finalState}&id_token=${idToken}`;
                    }
                }
            }

            if (contentNameSplit[2] === currentDepartmentNumber && contentNameSplit[3].toLowerCase() === "home") {
                const homeData = [category, actualLink, false, false];
                departments[Number(currentDepartmentNumber) - 1].home = homeData;
            } else {
                departments[Number(currentDepartmentNumber) - 1].columns[Number(currentColumnNumber) - 1].push([
                    category,
                    actualLink,
                    false
                ]);
            }
        }
    }

    return departments;
};

/**
 * Get the link for the eSpot
 * @param local Boolean of whether or not the nav is deployed locally
 * @param brand The brand of the eSpot the nav wants
 * @returns a String url for the eSpot
 */
export const getESpotLink = async (brand: string, vaultValues: any) => {
    const onEcomm = getEnvironment();
    let url = "";

    if (brand.toLowerCase() === "chevrolet") {
        if (onEcomm === 2) {
            url = "/api/ecom/nav";
        }
        url += vaultValues.chevroletESpotPath;
    } else if (brand.toLowerCase() === "buick") {
        if (onEcomm === 2) {
            url = "/api/ecom/nav";
        }
        url += vaultValues.buickESpotPath;
    } else if (brand.toLowerCase() === "gmc") {
        if (onEcomm === 2) {
            url = "/api/ecom/nav";
        }
        url += vaultValues.gmcESpotPath;
    } else if (brand.toLowerCase() === "cadillac") {
        if (onEcomm === 2) {
            url = "/api/ecom/nav";
        }
        url += vaultValues.cadillacESpotPath;
    } else {
        console.error(i18n.t("ERROR_INVALID_BRAND"));
        return "";
    }

    return url;
};

/**
 * This will check the url to get the branding, if the branding is not in the URL it will use the else case
 * If you are on local you will need to change the else case here and in global.ts
 */
export const getBrandFromURL = () => {
    const hostname = window.location.hostname;
    if (hostname.includes("localhost")) {
        const port = window.location.port;
        if (port.includes("8087") || port.includes("8093")) {
            return "chevrolet";
        } else if (port.includes("8083") || port.includes("8091")) {
            return "buick";
        } else if (port.includes("8082") || port.includes("8094")) {
            return "gmc";
        } else if (port.includes("8081") || port.includes("8092")) {
            return "cadillac";
        } else {
            return "chevrolet";
        }
    } else {
        if (hostname.toLowerCase().includes("chevrolet")) {
            return "chevrolet";
        } else if (hostname.toLowerCase().includes("buick")) {
            return "buick";
        } else if (hostname.toLowerCase().includes("gmc")) {
            return "gmc";
        } else if (hostname.toLowerCase().includes("cadillac")) {
            return "cadillac";
        } else {
            return "chevrolet";
        }
    }
};

/**
 * This function tells the nav if it is on an eComm site or not and which eComm Site it's on
 * @returns 0 for Accs/Local, 1 for Parts, 2 for non-eComm
 */
export const getEnvironment = (eVarLookup = false) => {
    const currentLocationHost = window.location.host;
    const currentLocation = window.location.href;
    let onEComm = 2;

    if (currentLocationHost.includes("localhost")) {
        if (window.location.port === "4200") {
            onEComm = 2;
        } else if (window.location.port.substring(1, 3) === "08") {
            onEComm = 0;
        } else if (window.location.port.substring(1, 3) === "09") {
            onEComm = 1;
        }
    } else {
        if (currentLocationHost.includes("parts")) {
            onEComm = 1;
        } else if (currentLocationHost.includes("accs") || currentLocationHost.includes("accessories")) {
            onEComm = 0;
        } else if (currentLocation.includes("onstar") && eVarLookup) {
            return 3;
        }
    }

    return onEComm;
};

/**
 * This function returns the rules for which department's categories require the eVar25 parameter
 * @param link The link for which the eVar is being added to
 * @returns A list that contains which departments should have the eVar25 parameter and what the parameter should contain
 */
export const getEVarConfig = (link: string) => {
    let brand = getBrandFromURL();
    if (brand === "cadillac") {
        brand = "ca";
    } else if (brand === "chevrolet") {
        brand = "ch";
    }

    let onEComm = getEnvironment(true);

    let eVarConfig = "";

    const itemEnvironment = checkItemEnvironment(link);

    if (itemEnvironment === 0 || itemEnvironment === 1) {
        // Linking to eComm
        if (onEComm < 2) {
            // On an eComm Site
            eVarConfig = "";
        } else if (onEComm === 2) {
            // On brand.com
            eVarConfig = "?eVar25=" + brand + "_nav-secondary";
        } else if (onEComm === 3) {
            // On OwnerCenter
            eVarConfig = "?eVar25=oc_" + brand + "_nav-secondary";
        }
    } else if (itemEnvironment === 2) {
        // Linking to OwnerCenter
        if (onEComm === 0) {
            // On Accs
            eVarConfig = "?eVar18=acc_" + brand + "_nav-secondary";
        } else if (onEComm === 1) {
            // On Parts
            eVarConfig = "?eVar18=parts_" + brand + "_nav-secondary";
        } else if (onEComm === 2) {
            // On brand.com
            eVarConfig = "?eVar18=" + brand + "_nav-secondary";
        } else if (onEComm === 3) {
            // On OwnerCenter
            eVarConfig = "";
        }
    } else {
        // Linking to brand
        if (onEComm === 0) {
            // On Accs
            eVarConfig = "?eVar25=acc_" + brand + "_nav-secondary";
        } else if (onEComm === 1) {
            // On Parts
            eVarConfig = "?eVar25=parts_" + brand + "_nav-secondary";
        } else if (onEComm === 2) {
            // On brand.com
            eVarConfig = "";
        } else if (onEComm === 3) {
            // On OwnerCenter
            eVarConfig = "?eVar25=oc_" + brand + "_nav-secondary";
        }
    }

    return eVarConfig;
};

/**
 *
 * @param url Checks the environment of the url that
 * @returns If the url is a parts url return 0, accs 1, ownercenter 2, else 3
 */
export const checkItemEnvironment = (url: string) => {
    if (url.includes("localhost")) {
        if (["8093", "8091", "8094", "8092"].some((port) => url.includes(port))) {
            return 0;
        } else if (["8087", "8083", "8082", "8081"].some((port) => url.includes(port))) {
            return 1;
        } else {
            return 3;
        }
    } else {
        if (url.includes("parts")) {
            return 0;
        } else if (url.includes("accs") || url.includes("https://accessories")) {
            return 1;
        } else if (url.includes("ownercenter")) {
            return 2;
        } else {
            return 3;
        }
    }
};

/**
 * This function takes in a Parameterized link and replaces the parameters with the actual values based on the location of the nav
 * @param link The parameterized link from the eSpot
 * @param vaultValues The Vault Values Object of All Necessary Parameters
 * @returns The link with the parameters replaced
 */
export const parseESpotLink = async (link: string, vaultValues: object) => {
    let parsedLink = "";
    let lowerBound = 0;
    if (link != undefined) {
        let upperBound = link.indexOf("{");

        while (upperBound !== -1) {
            parsedLink += link.substring(lowerBound, upperBound);
            link = link.substring(0, upperBound) + " " + link.substring(upperBound + " ".length);
            lowerBound = upperBound + 1;
            upperBound = link.indexOf("}");
            link = link.substring(0, upperBound) + " " + link.substring(upperBound + " ".length);
            let vaultValueName = link.substring(lowerBound, upperBound);

            parsedLink += vaultValues[vaultValueName];
            lowerBound = upperBound + 1;
            upperBound = link.indexOf("{");
        }
    }

    parsedLink += link.substring(lowerBound);

    return parsedLink.trim();
};

/**
 * Generates a storage key for mobile account authentication
 * @param azureClientId The Azure client ID from vault configuration
 * @param tokenBaseUrl The base URL for Azure access token
 * @returns A formatted storage key string
 */
export const generateMobileAccountKey = (azureClientId: string, tokenBaseUrl: string): string => {
    const authEnv = String(tokenBaseUrl)
        .replace(/^https?:\/\//, "")
        .replace(/:\d+$/, "");

    return `${azureClientId}-${authEnv}-idToken`;
};

/**
 * Retrieves the mobile account value from localStorage using the generated key
 * @param key The storage key generated from generateMobileAccountKey
 * @returns The stored value or null if not found
 */
export const getMobileAccountValue = (key: string): string | null => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.error("Error accessing localStorage:", error);
        return null;
    }
};

/**
 * Decodes and parses a JWT token payload
 * @param token The JWT token string to decode
 * @returns Decoded token payload as object or null if invalid/error
 */
export const decodeJWTPayload = (token: string) => {
    try {
        const splitToken = token.split(".");
        if (splitToken.length !== 3) return null;

        const payload = splitToken[1];
        const base64 = payload.replace(/-g/, "+").replace(/_/g, "/");
        const decodedPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );

        return JSON.parse(decodedPayload);
    } catch (error) {
        console.error("Error decoding JWT payload:", error);
        return null;
    }
};

/**
 * Validates an OnStar token by checking its ACR claim against expected policy
 * @param decodedToken The decoded JWT token object
 * @param policyValue The expected Azure policy value to validate against
 * @returns Boolean indicating if token is valid
 */
export const validateOnStarToken = (decodedToken: any, policyValue: string) => {
    return decodedToken?.acr === policyValue;
};

/**
 * Handles token validation logic for different environments
 * @param environment Current environment number (0/1 for Parts/Accessories, 3 for OnStar)
 * @param vaultValues Object containing vault configuration values
 * @returns Object containing shouldModifyUrls flag and idToken if valid
 */
export const handleTokenValidation = (environment: number, vaultValues: any) => {
    let shouldModifyUrls = false;
    let idToken = null;

    if (environment === 0 || environment === 1) {
        // Parts/Accessories environment
        const mobileAccountKey = generateMobileAccountKey(
            vaultValues.azureClientIdTargetable,
            vaultValues.azureAccessTokenBaseUrl
        );
        const mobileAccountValue = getMobileAccountValue(mobileAccountKey);

        if (mobileAccountValue) {
            try {
                const accountObject = JSON.parse(mobileAccountValue);
                if (accountObject.secret) {
                    shouldModifyUrls = true;
                    idToken = accountObject.secret;
                }
            } catch (error) {
                console.error("Error parsing localStorage value:", error);
            }
        }
    } else {
        // Brand Sites Environment
        try {
            if ((window as any).gbpe?.auth?.idToken) {
                const testIdToken = (window as any).gbpe.auth.idToken;
                const decodedToken = decodeJWTPayload(testIdToken);

                if (decodedToken && validateOnStarToken(decodedToken, vaultValues.azureMobileClientPolicy)) {
                    shouldModifyUrls = true;
                    idToken = (window as any).gbpe.auth.idToken;
                }
            }
        } catch (error) {
            console.error("Error processing OnStar token:", error);
        }
    }

    return { shouldModifyUrls, idToken };
};
